import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SmartTagAudiencesForPickerQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type SmartTagAudiencesForPickerQuery = {
  __typename?: 'Query';
  smartTagAudiences: Array<{ __typename?: 'SmartTagAudienceOption'; resolver: string; params: any; labelKey: string; memberCount: number; capped: boolean }>;
};

export const SmartTagAudiencesForPickerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmartTagAudiencesForPicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smartTagAudiences' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resolver' } },
                { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'capped' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSmartTagAudiencesForPickerQuery__
 *
 * To run a query within a React component, call `useSmartTagAudiencesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartTagAudiencesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartTagAudiencesForPickerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSmartTagAudiencesForPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SmartTagAudiencesForPickerQuery, SmartTagAudiencesForPickerQueryVariables>) {
  return ApolloReactHooks.useQuery<SmartTagAudiencesForPickerQuery, SmartTagAudiencesForPickerQueryVariables>(SmartTagAudiencesForPickerDocument, baseOptions);
}
export function useSmartTagAudiencesForPickerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SmartTagAudiencesForPickerQuery, SmartTagAudiencesForPickerQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<SmartTagAudiencesForPickerQuery, SmartTagAudiencesForPickerQueryVariables>(SmartTagAudiencesForPickerDocument, baseOptions);
}
export type SmartTagAudiencesForPickerQueryHookResult = ReturnType<typeof useSmartTagAudiencesForPickerQuery>;
export type SmartTagAudiencesForPickerLazyQueryHookResult = ReturnType<typeof useSmartTagAudiencesForPickerLazyQuery>;
export type SmartTagAudiencesForPickerQueryResult = Apollo.QueryResult<SmartTagAudiencesForPickerQuery, SmartTagAudiencesForPickerQueryVariables>;
